import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {NavigateFunction, useNavigate} from 'react-router'

import {QueryKeyName} from '../../common/backend'
import {getDocsLink} from '../../common/backend/referenceLinks'
import {handleError, retryFunction} from '../apiErrorHandler'

export const useDocsLink = () => {
  const navigate: NavigateFunction = useNavigate()
  const result = useQuery({
    queryKey: [QueryKeyName.GetDocsLink],
    queryFn: () => getDocsLink(),
    retry: retryFunction
  })
  const error: AxiosError | null = result.error
  if (error) {
    handleError(error, navigate)
  }

  return result
}
